import React from 'react'
import { useLazyGetNotificationsQuery } from '../../store/kopiliot-api/notification'
import { createEntityQueryReducer } from '../../hooks/create-entity-pagination-reducer'
import {
  NotificationQuery,
  SortOrderDirection,
} from '../../store/kopiliot-api/query-type'
import {
  PaginationActions,
  PaginationActionType,
} from '../../hooks/pagination-reducer'
import { Notification } from '../../shared/models/notification.model'
import { useGenericReducer } from '../../hooks/generic-hook'
import KopiliotList from '../../components/kopiliot-list/KopiliotList'
import { useNavigate } from 'react-router-dom'
import {
  defaultNotificationActionsRow,
  getColumnsForTableNotifications,
} from '../../features/notifications/notification-columns'
import { NotificationID } from '../../shared/models/id/notification_id'
import ViewNotification from '../../features/notifications/modal/ViewNotification'

const NotificationInbox = () => {
  const navigate = useNavigate()
  const [getNotifications, resultGetNotifications] =
    useLazyGetNotificationsQuery()
  const [currentNotification, setCurrentNotification] = React.useState<
    NotificationID | undefined
  >(undefined)
  const reducer = React.useMemo(() => {
    return createEntityQueryReducer<NotificationQuery, PaginationActions>({
      handleSpecificActions: {},
    })
  }, [])
  const [paginationState, dispatchPaginationAction] = useGenericReducer<
    typeof reducer,
    NotificationQuery,
    PaginationActions
  >(reducer, {
    textSearch: '',
    limit: 20,
    offset: 0,
    sortOrder: {
      property: 'createdAt',
      direction: SortOrderDirection.DESC,
    },
  })

  React.useEffect(() => {
    getNotifications(paginationState)
  }, [
    paginationState.offset,
    paginationState.limit,
    paginationState.textSearch,
  ])
  const onDelete = (id: string) => {}
  const onClick = (id: string) => {
    setCurrentNotification(new NotificationID(id))
  }
  const isLoadingData =
    resultGetNotifications.isLoading || resultGetNotifications.isFetching

  return (
    <>
      <ViewNotification
        id={currentNotification}
        show={currentNotification != undefined}
        onHide={() => {
          setCurrentNotification(undefined)
        }}
      />
      <KopiliotList
        title={'Destinataires'}
        icon={'users-viewfinder'}
        isLoading={isLoadingData}
        actionsProps={{
          onRefresh: () => {
            getNotifications(paginationState)
          },
        }}
        data={resultGetNotifications.data}
        paginationProps={{
          pageLimit: paginationState.limit,
          totalRecords: resultGetNotifications.data?.totalRows || 0,
          onPageChanged: (page: {
            currentPage: number
            totalPages: number
            pageLimit: number
          }) => {
            dispatchPaginationAction({
              type: PaginationActionType.PAGE_CHANGE,
              payload: { ...page },
            })
          },
          onChangePageSize: (size: number) => {
            dispatchPaginationAction({
              type: PaginationActionType.PAGE_SIZE,
              payload: { pageSize: size },
            })
          },
        }}
        tableProps={{
          tableProps: {
            size: 'sm',
            className: 'mb-0 overflow-hidden table-hover cursor-pointer',
          },
          rowClassName: 'default__table-row align-middle fs-10',
          hiddenColumns: ['id'],
          headerClassName: 'bg-200 text-900 text-nowrap align-middle',
          cellClassName: 'py-2 pe-4',
          columns: getColumnsForTableNotifications(
            defaultNotificationActionsRow(onDelete)
          ),
          onClickRow: (row) => {
            if (row.original.id) {
              onClick(row.original.id?.id)
            }
          },
        }}
        cardProps={{
          idAccessor: (item: Notification) => item.id!.id,
          titleAccessor: (item: Notification) => item.subject ?? '',
          descriptionAccessor: (item: Notification) => item?.subject ?? '',
          linkAccessor: (item: Notification) => `${item.id!.id}`,
          actionsRow: defaultNotificationActionsRow(onDelete),
        }}
      />
    </>
  )
}

export default NotificationInbox
